import {
  DashboardContentPlaceholder,
  DashboardCardContent,
  DashboardCardHeader,
  DashboardCard,
} from '@pages/dashboard/components';
import { useNotificationsCount } from '@core/router/company-route/company-layout/navbar/use-notifications-count';
import { useGetNotifications, useHasPermission } from '@shared/hooks';
import { useTranslation } from 'react-i18next';
import { Bell } from '@ui/components/icons';
import { Routes } from '@shared/enums';
import { cn } from '@ui/utils';
import React from 'react';

import { DashboardNotificationsList } from './dashboard-notifications-list';

export const DashboardNotifications = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { className, ...rest } = props;
  const notificationsCount = useNotificationsCount();
  const hasPermission = useHasPermission('DASHBOARD_NOTIFICATIONS_SEE_ALL', 'READ');

  const { data: notifications, isLoading } = useGetNotifications({
    request: {
      pagination: {
        pageIndex: 0,
        pageSize: 3,
      },
    },
  });

  const { t } = useTranslation();
  return (
    <DashboardCard className={cn(className)} {...rest}>
      <DashboardCardHeader
        link={{ label: t('DASHBOARD.NOTIFICATIONS.SEE_ALL'), href: `../${Routes.NOTIFICATIONS}` }}
        title={t('DASHBOARD.NOTIFICATIONS.TITLE')}
        isLinkVisible={hasPermission}
        counter={notificationsCount}
        className="mb-6"
        icon={<Bell />}
      />

      <DashboardCardContent isLoading={isLoading}>
        {!!notifications?.data.length ? (
          <DashboardNotificationsList notifications={notifications.data} />
        ) : (
          <DashboardContentPlaceholder
            title={t('DASHBOARD.NOTIFICATIONS.PLACEHOLDER_TITLE')}
            icon={<Bell />}
          />
        )}
      </DashboardCardContent>
    </DashboardCard>
  );
};
